import React from "react";
import "./HeroCarousel.css";
import poultry from "../../assets/videos/chicken.mp4";
import animal from "../../assets/videos/animal.mp4";
import aqua from "../../assets/videos/fishfly2.mp4";

const HeroCarousel = () => {
  return (
    <section>
      <div className="">
        {/* Bootstrap Carousel */}
        <div
          id="videoCarousel"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          {/* Carousel Indicators */}
          <div className="carousel-indicators">
            <button
              type="button"
              data-bs-target="#videoCarousel"
              data-bs-slide-to="0"
              className="active"
              aria-current="true"
              aria-label="Slide 1"
            ></button>
            <button
              type="button"
              data-bs-target="#videoCarousel"
              data-bs-slide-to="1"
              aria-label="Slide 2"
            ></button>
            <button
              type="button"
              data-bs-target="#videoCarousel"
              data-bs-slide-to="2"
              aria-label="Slide 3"
            ></button>
          </div>

          {/* Carousel Items */}
          <div className="carousel-inner">
            {/* Slide 1 */}
            <div className="carousel-item active">
              <div className="video-gradient-wrapper">
                <video className="d-block w-100" autoPlay loop muted>
                  <source src={poultry} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <div className="carousel-caption custom-carousel-caption col-md-12">
                <h5 className="poultry-name">
                  P<span className="egg-o">o</span>ultry
                </h5>
                <p
                  className="animate__animated animate__backInLeft animate__slow"
                  style={{ fontFamily: "italic" }}
                >
                  Improving human health through animal health
                </p>
                <a
                  href="#learn-more-1"
                  className="btn btn-primary animate__animated animate__fadeIn"
                >
                  Explore Poultry Group
                </a>
              </div>
            </div>

            {/* Slide 2 */}
            <div className="carousel-item">
              <div className="video-gradient-wrapper">
                <video className="d-block w-100" autoPlay loop muted>
                  <source src={animal} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <div className="carousel-caption custom-carousel-caption">
                <h5 className="animal-health-name">
                  Ani<span className="letter-m">M</span>al Health
                </h5>
                <p
                  className="animate__animated animate__backInLeft animate__slow"
                  style={{ fontFamily: "italic" }}
                >
                  Ensuring animal well-being for a better future
                </p>
                <a
                  href="#learn-more-2"
                  className="btn btn-primary animate__animated animate__fadeIn"
                >
                  Discover Animal Care
                </a>
              </div>
            </div>

            {/* Slide 3 */}
            <div className="carousel-item">
              <div className="video-gradient-wrapper">
                <video className="d-block w-100" autoPlay loop muted>
                  <source src={aqua} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <div className="carousel-caption custom-carousel-caption">
                <h5 className="aquaculture-name">Aquaculture</h5>
                <p
                  className="animate__animated animate__backInLeft animate__slow"
                  style={{ fontFamily: "italic" }}
                >
                  Supporting sustainable water-based farming
                </p>
                <a
                  href="#learn-more-3"
                  className="btn btn-primary animate__animated animate__fadeIn"
                >
                  Learn About Aquaculture
                </a>
              </div>
            </div>
          </div>

          {/* Carousel Controls */}
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#videoCarousel"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#videoCarousel"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroCarousel;
